import { render, staticRenderFns } from "./page-qr.vue?vue&type=template&id=776a7427&scoped=true&"
import script from "./page-qr.vue?vue&type=script&lang=js&"
export * from "./page-qr.vue?vue&type=script&lang=js&"
import style0 from "./page-qr.vue?vue&type=style&index=0&id=776a7427&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776a7427",
  null
  
)

export default component.exports